/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 24th 2023, 12:12:50 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export const Transformers = {
  emptyNumberToNull: (value: string) => ([NaN, ""].includes(value) ? null : value),
  emptyNumberToZero: (value: string) => ([NaN, ""].includes(value) ? 0 : value),
};
